import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { Button, Collapse, ListGroup } from "react-bootstrap";
import { studyOnboardingService } from "../APIServices/studyOnboarding";
import { usersOnboardingService } from "../Services/usersOnboarding";

const SwitchAccess = ({ clientLabel, projectLabel, StudyMode }) => {
  const AppsRef = useRef(null);
  const { studyId } = useParams();
  const [AppsActive, setAppsActive] = useState("");
  const previousRole = JSON.parse(localStorage.getItem("previousRole"));

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setAppsActive("");
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const previousMode = JSON.parse(localStorage.getItem("previousMode"));
  const loginType = JSON.parse(localStorage.getItem("loginType"));
  const category = JSON.parse(localStorage.getItem("role"));
  const [studyLabel, setStudyLabel] = useState("");
  const [projectID, setProjectID] = useState("");

  const getProjectIdByStudyId = async () => {
    let projectId = await studyOnboardingService.getProjectIdByStudyId(studyId);
    setProjectID(projectId?.data?.project_id);
  };

  const findStudyLabel = async () => {
    let data = await usersOnboardingService.findStudyLabel(studyId);
    setStudyLabel(data?.data);
  };

  useEffect(() => {
    getProjectIdByStudyId();
    findStudyLabel();
  }, [studyId]);

  const addStudyAppsLoginHistory = async () => {
    let userData = {};
    userData.client = clientLabel;
    userData.projectId = projectID;
    userData.projectLabel = projectLabel;
    userData.studyId = studyId;
    userData.studyLabel = studyLabel;
    userData.status = "logout";
    userData.category = category;
    userData.mode = StudyMode;
    let data = await studyOnboardingService.addStudyAppsLoginHistory(userData);
    if(data?.statusCode === 200){
      loginMainDashboard()
    }
  };

  const addStudyLoginHistory = async () => {
    let userData = {};
    userData.client = clientLabel;
    userData.projectId = projectID;
    userData.projectLabel = projectLabel;
    userData.studyId = studyId;
    userData.studyLabel = studyLabel;
    userData.status = "logout";
    userData.mode = StudyMode;
    let data = await studyOnboardingService.addStudyLoginHistory(userData);
    if(data?.statusCode === 200){
       if(category === "ctms"){
        loginMainDashboard()
      }
    }
  };

  const loginMainDashboard = () => {
    if (loginType === "normal") {
      if (previousRole === "user") {
        window.location.href = `/userRole`;
        localStorage.removeItem("previousRole");
        localStorage.setItem("role", JSON.stringify("user"));
        localStorage.removeItem("previousMode");
        localStorage.removeItem("StudyMode");
        localStorage.removeItem("studyTabs");
        localStorage.removeItem("studyPermissionData");
        localStorage.removeItem("iwrsPermissionData");
        localStorage.removeItem("studyStatus");
        localStorage.removeItem("tabs");
      } else if (previousRole === "ctms") {
        window.location.href = `/ctms/${studyId}`;
        localStorage.removeItem("regularStudySubject");
        localStorage.removeItem("regularAssignVisitForm");
        localStorage.setItem("previousRole", JSON.stringify("user"));
        localStorage.setItem("role", JSON.stringify("ctms"));
        localStorage.setItem("StudyMode", JSON.stringify(previousMode));
      }
    } else {
      window.location.href = `/userRole`;
      localStorage.setItem("role", JSON.stringify("user"));
      localStorage.setItem(
        "loginType",
        JSON.stringify(loginType === "multiStudies" ? "studies" : "apps")
      );
      localStorage.removeItem("StudyMode");
      localStorage.removeItem("studyTabs");
      localStorage.removeItem("studyPermissionData");
      localStorage.removeItem("iwrsPermissionData");
      localStorage.removeItem("studyStatus");
    }
    localStorage.removeItem("studyTabs");
  };

  return (
    <div ref={AppsRef}>
      <Button
        className="position-relative border-0 py-1 px-2 text-start br3"
        variant="outline-light"
        onClick={() => setAppsActive(!AppsActive)}
      >
        <div className="hstack gap-1">
          <i
            className="fa-solid fa-repeat me-1 text-info"
            style={{ fontSize: 12 }}
          ></i>
          <p className="m-0" style={{ fontSize: 13 }}>
            Switch
          </p>
          <i
            className={`fa-solid fa-angle-${AppsActive ? "up" : "down"}`}
            style={{ fontSize: 12 }}
          ></i>
        </div>
        <Collapse in={AppsActive === true}>
          <div className="position-absolute z-1 end-0" style={{ top: 33 }}>
            <ListGroup style={{ fontSize: 12, width: "max-content" }}>
              <ListGroup.Item action onClick={category === "ctms" ? addStudyLoginHistory : addStudyAppsLoginHistory}>
                <i className="fa-solid fa-house-circle-check me-2"></i>Switch to
                {category === "ctms" ? " main" : " CTMS"} dashboard
              </ListGroup.Item>
            </ListGroup>
          </div>
        </Collapse>
      </Button>
    </div>
  );
};

export default SwitchAccess;
